/** Tempo restante de pausa em português (ex.: "1 hora", "45 minutos"). */
export function formatPauseRemainingPtBr(diffMs: number): string {
  if (diffMs <= 0) return ''
  const sec = Math.ceil(diffMs / 1000)
  const days = Math.floor(sec / 86400)
  const hours = Math.floor((sec % 86400) / 3600)
  const minutes = Math.floor((sec % 3600) / 60)
  if (days > 0) {
    return days === 1 ? '1 dia' : `${days} dias`
  }
  if (hours > 0) {
    return hours === 1 ? '1 hora' : `${hours} horas`
  }
  if (minutes > 0) {
    return minutes === 1 ? '1 minuto' : `${minutes} minutos`
  }
  return 'menos de 1 minuto'
}

export type AutomationUiState = 'ligada' | 'pausada' | 'desligada'

export function getAutomationUiState(contact: {
  assistant_is_active?: boolean | null
  assistant_disabled_until?: string | null
}): AutomationUiState {
  const active = contact.assistant_is_active ?? false
  const until = contact.assistant_disabled_until
  if (active) return 'ligada'
  if (!until) return 'desligada'
  // Pausa em curso: ainda não chegou na hora marcada.
  if (new Date(until).getTime() > Date.now()) return 'pausada'
  // Pausa vencida mas a flag ainda não foi flipada (cron / webhook / fast-path no painel).
  // Tratamos como ligada para a UI não mostrar "Desligada" enganosamente.
  return 'ligada'
}
